define('services/mymessage/mymessage.service',['app'], function (app) {
    return app.factory('mymessageService', ['$q','OpenOther','auiDialog','$sce', function ($q, OpenOther,auiDialog,$sce) {


    	function queryMessageLikeList(paramReq){
            var defer = $q.defer();
            var param = {
                	req:{
	                    offset:1,
	                    pageCount:20,
	                    sortField:'sendTime',
	                    sortType:'DESC',
	                    searchTxt : paramReq.searchTxt,
	                    msgType:0
                	}
                };
            OpenOther.queryStationMsgList(param).then(function(resp){
                var result = [];
                var messageList = resp && resp.developerStationMsgList;
                if (messageList && messageList.length > 0) {
                    for (var i in messageList) {
                        if (messageList[i].subject.indexOf(paramReq.searchTxt) != -1) {
                            result.push(messageList[i].subject);
                        }
                    }
                }
                defer.resolve(result);
            });
            return defer.promise;
        }

        function queryMessageList (paramReq) {
        	var defer = $q.defer();
            var param = {
                offset:paramReq.offset,
                pageCount:paramReq.pageCount,
                sortField:'sendTime',
                sortType:'DESC',
                msgType:0
            };
            if(paramReq.searchTxt != ''){
                param.searchTxt = paramReq.searchTxt;
            }
            if(paramReq.status && paramReq.status.length && paramReq.status.length == 1){
                param.status = paramReq.status[0];
            }
            var searchParams = {
            		req:param
            }
            OpenOther.queryStationMsgList(searchParams).then(function(resp){
                defer.resolve(resp);
            });
            return defer.promise;
        }

        function queryMessageDetail(msgID){
        	var defer = $q.defer();
            // 查询站内信详细
            var params = {
                req:{
                    msgID : msgID
                }
            }
            OpenOther.getStationMessage(params).then(function(resp){
            	var result = {};
            	result.messageDetail = resp.stationMessage;

                var messageBody = resp.stationMessage.body;
                var reg = /<img +src\="[^"]+/g;
                var imgs = messageBody.match(reg);

                var reg1 = /<img +src\="/g;
                var pics = resp.stationMessage.pics?JSON.parse(resp.stationMessage.pics):[];

                var reg2 = /<a +href\="[^"]+/g;
                var attachs = messageBody.match(reg2);

                var reg3 = /<a +href\="/g;
                var links = resp.stationMessage.attachs?JSON.parse(resp.stationMessage.attachs):[];

                for (var i in imgs) {
                    var tmp = imgs[i].replace(reg1, "");
                    for (var j in pics) {
                        if (imgs[i].match(pics[j].name + "$")) {
                            messageBody = messageBody.replace(tmp, pics[j].url);
                        }
                    }
                }
                for (var k in attachs) {
                    var tmpk = attachs[k].replace(reg3, "");
                    for (var l in links) {
                        if (attachs[k].match(links[l].name + "$")) {
                            messageBody = messageBody.replace(tmpk, links[l].url);
                        }
                    }
                }

                result.tabType = 'messageDetail';
                defer.resolve(result);

            });

            return defer.promise;
        }

        function delNews(msgID) {
        	var defer = $q.defer();
            var params = {
              req:{
                  msgID : msgID
              }
          }
            auiDialog.confirm("确认要删除信息？", function () {
              OpenOther.delStationMessage(params).then(function(data){
                  defer.resolve(data);
              }).catch(function (data) {
            	  defer.reject(data);
              });
          });

          return defer.promise;
      }

      //设置第几个已读
      function setReaderedIndex(msgID,lst){
    	  var defer = $q.defer();
    	  for(var i = 0; i<lst.length ;i++){
              if(lst[i].msgID == msgID){
            	  if(lst[i].readStatus != '1'){
            		  lst[i].readStatus = '1';
              	  }
                  break;
              }

          }
    	  defer.resolve();
    	  return defer.promise;
      }



        return {
        	queryMessageLikeList:queryMessageLikeList,
        	queryMessageList:queryMessageList,
        	queryMessageDetail:queryMessageDetail,
        	delNews:delNews,
        	setReaderedIndex:setReaderedIndex
        }

    }]);
});


